// extracted by mini-css-extract-plugin
export var actions = "_td-4";
export var item = "_td-1";
export var price = "_td-3";
export var quantity = "_td-2";
export var table = "_td-0";